<template>
    <header class="header">
        <div class="header-content">
            <nav v-if="!isLoggedIn" class="header-links">
                <a href="#how-it-works">How It Works</a>
                <a href="#benefits">Benefits</a>
                <a href="#faq">FAQ</a>
            </nav>
            <div v-else class="header-links-spacer"></div>
            <div class="logo">
                <a href="/"><img src="@/assets/logo-sm.png" alt="Colirize" class="logo-image"></a>
            </div>
            <div class="nav-items">
                <span v-if="isLoggedIn" class="tokens">Tokens: <span>{{ tokens }}</span></span>
                <button v-if="!isLoggedIn" @click="showSignup = true" class="signup-btn">Get Started <i class="icon icon-right-arrows"></i></button>
                <button v-if="!isLoggedIn" @click="showLogin = true" class="login-btn">Log In <i class="icon icon-login"></i></button>
                <button v-if="isLoggedIn && !hasPremium" @click="showPlans = true" class="premium-btn">Get Tokens <i class="icon icon-check"></i></button>
                <button v-if="isLoggedIn" @click="showSettings = true" class="settings-btn">Settings <i class="icon icon-settings"></i></button>
            </div>
        </div>
    </header>
    <div class="model signup" v-if="showSignup">
        <div class="model-container">
            <div>
                <h2>Sign Up</h2>
                <button @click="showSignup = false" class="model-close"><i class="icon icon-close"></i></button>
            </div>
            <div>
                <form @submit.prevent="signup">
                    <input v-model="email" type="email" placeholder="Email">
                    <div class="password-container">
                        <input v-model="password.password" type="password" placeholder="Password">
                        <i @click="showPasswordInfo = !showPasswordInfo" class="icon icon-info"></i> 
                        <div v-if="showPasswordInfo" class="password-info">
                            <p>Password Requirements:</p>
                            <div>
                                <ul>
                                    <li>Minimum length of 6 characters</li>
                                    <li>At least one lowercase letter</li>
                                    <li>At least one uppercase letter</li>
                                    <li>At least one number</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="submit-btn">Sign Up <i class="icon icon-right-arrows"></i></button>
                </form>
                <div class="other">
                    Or Log In Using: 
                    <button @click="googleAuth" class="google-btn">Continue with Google <i class="icon icon-google"></i></button>
                </div>
                <div v-if="error" class="error-text">
                    <p>{{ error }}</p>
                </div>
                <div class="footer">
                    <a href="/privacy-policy.html" target="_blank">Privacy Policy</a>
                    <a href="/terms-and-conditions.html" target="_blank">Terms and Conditions</a>
                </div>
            </div> 
        </div>
    </div>

    <div class="model login" v-if="showLogin">
        <div class="model-container">
            <div>
                <h2>Log In</h2>
                <button @click="showLogin = false" class="model-close"><i class="icon icon-close"></i></button>
            </div>
            <div>
                <form @submit.prevent="login">
                    <input v-model="email" type="email" placeholder="Email">
                    <input v-model="password.password" type="password" placeholder="Password">
                    <button type="submit" class="submit-btn">Log In <i class="icon icon-right-arrows"></i></button>
                </form>
                <div class="other">
                    Or Log In Using: 
                    <button @click="googleAuth" class="google-btn">Continue with Google <i class="icon icon-google"></i></button>
                </div>
                <div class="reset-password">
                    <button @click="resetLoggedOutPasswordRequest">Forgot Password? Click to reset.</button>
                </div>
                <div v-if="error" class="error-text">
                    <p>{{ error }}</p>
                </div>
            </div> 
        </div>
    </div>

    <div class="model password-reset" v-if="showPasswordReset">
        <div class="model-container">
            <div>
                <h2>Reset Password</h2>
                <button @click="showPasswordReset = false" class="model-close"><i class="icon icon-close"></i></button>
            </div>
            <div>
                <div class="password-container">
                    <input v-model="password.password" type="password" placeholder="Password">
                    <i @click="showPasswordInfo = !showPasswordInfo" class="icon icon-info"></i> 
                    <div v-if="showPasswordInfo" class="password-info">
                        <p>Password Requirements:</p>
                        <div>
                            <ul>
                                <li>Minimum length of 6 characters</li>
                                <li>At least one lowercase letter</li>
                                <li>At least one uppercase letter</li>
                                <li>At least one number</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <input v-model="password.confirm" type="password" placeholder="Confirm Password">
                <button @click="resetPassword" class="submit-btn">Reset Password <i class="icon icon-right-arrows"></i></button>
                <div v-if="error" class="error-text">
                    <p>{{ error }}</p>
                </div>
            </div> 
        </div>
    </div>

    <div class="model plans" v-if="showPlans">
        <div class="model-container">
            <div>
                <h2>Token Packs</h2>
                <button @click="showPlans = false" class="model-close"><i class="icon icon-close"></i></button>
            </div>
            <div class="plans_wrapper">
                <div class="plan">
                    <h3>1,000 Tokens</h3>
                    <h4>${{ plans['51CE5A4D-7807-42E1-B2CD-562FC9A9926E'] }} USD</h4>
                    <p class="feature"><i class="icon icon-check"></i> Starter Pack</p>
                    <p class="feature"><i class="icon icon-check"></i> Image Storage</p>
                    <!-- <p class="feature"><i class="icon icon-check"></i> Image Storage</p> -->
                    <button v-if="isLoggedIn" @click="selectPlan('51CE5A4D-7807-42E1-B2CD-562FC9A9926E')" class="setting-btn">Purchase</button>
                </div>
                <div class="plan">
                    <h3>2,500 Tokens</h3>
                    <h4>${{ plans['8C9828A7-B647-404D-8827-25016A957534'] }} USD</h4>
                    <p class="feature"><i class="icon icon-check"></i> Pro Pack</p>
                    <p class="feature"><i class="icon icon-check"></i> Image Storage</p>
                    <!-- <p class="feature"><i class="icon icon-check"></i> Image Storage</p> -->
                    <button v-if="isLoggedIn" @click="selectPlan('8C9828A7-B647-404D-8827-25016A957534')" class="setting-btn">Purchase</button>
                </div>
                <div class="plan">
                    <h3>5,000 Tokens</h3>
                    <h4>${{ plans['DAAD61EC-7A50-4768-ABC9-FB2417D30CAD'] }} USD</h4>
                    <p class="feature"><i class="icon icon-check"></i> Studio Pack</p>
                    <p class="feature"><i class="icon icon-check"></i> Image Storage</p>
                    <!-- <p class="feature"><i class="icon icon-check"></i> Best Value</p> -->
                    <button v-if="isLoggedIn" @click="selectPlan('DAAD61EC-7A50-4768-ABC9-FB2417D30CAD')" class="setting-btn">Purchase</button>
                </div>
            </div>
        </div>
    </div>

    <div class="model payment" v-if="showPayment">
        <div class="model-container">
            <div>
                <h2>Payment</h2>
                <button @click="showPayment = false" class="model-close"><i class="icon icon-close"></i></button>
            </div>
            <div>
                <div class="form">
                    <div>
                        <label>Card Number</label>
                        <span class="input"><div id="card-number-element"></div></span>
                    </div>
                    <div class="double">
                        <div>
                            <label>Expiration Date</label>
                            <span class="input"><div id="card-expiry-element"></div></span>
                        </div>
                        <div>
                            <label>CVC</label>
                            <span class="input"><div id="card-cvc-element"></div></span>
                        </div>
                    </div>
                    <button @click="payWithStripe" v-bind:class="{ 'is-disabled' : submitting, error : stripe.failed }">{{ paymentButtonText }}</button>
                </div>
            </div>
        </div>
    </div>
    
    <div class="model settings" v-if="showSettings">
        <div class="model-container">
            <div>
                <h2>Settings</h2>
                <button @click="showSettings = false" class="model-close"><i class="icon icon-close"></i></button>
            </div>
            <div>
                <div class="setting">
                    <p>Log Out</p>
                    <button @click="logout" class="setting-btn">Log Out <i class="icon icon-right-arrows"></i></button>
                </div>
                <div class="setting">
                    <p>Reset Password</p>
                    <button @click="resetPasswordRequest" class="setting-btn">Reset <i class="icon icon-reset"></i></button>
                </div>
                <div class="setting">
                    <p>Delete Account</p>
                    <button @click="deleteAccount" class="setting-btn">Delete <i class="icon icon-trash"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { getApiBaseUrl } from '@/config/api-base.js';

// const LOGIN = 'Log In';
// const SIGNUP = 'Sign Up';
const INVALID_EMAIL = 'Invalid Email Address';
const INVALID_PASSWORD = 'Invalid Password';
// const PASSWORD_REQUIREMENTS = 'Invalid Password';
const MISSMATCH_PASSWORD = 'Passwords Don\'t Match';
const INVALID_LOGIN = 'Invalid Email Or Password';
// const ENTER_EMAIL = 'Enter Your Email';
const PROCESS = 'Process Payment';
const FAILED = 'Payment Failed';
const ENTER_EMAIL = 'Enter Your Email Above To Reset';
// const RESET = 'Reset Password';

if (window.utils.hash('access_token')) {
    window.services.google({
        'token': window.utils.hash('access_token')
    })
    .then(function () {
        window.location.href = window.location.origin;
    })
    .catch(function () {
        Swal.fire({
            title: 'Login Failed',
            text: "Sorry, something went wrong while trying to login to your google account.",
            type: 'warning',
        }).then(() => {
            window.location.href = window.location.origin;
        });
    });
}

export default {
    name: 'TopHeader',
    emits: ['session-invalidated'],
    data() {
        return {
            services: window.services,
            utils: window.utils,
            Stripe: window.Stripe,
            showSignup: false,
            showLogin: false,
            showSettings: false,
            showPlans: false,
            showPayment: false,
            showPasswordReset: false,
            // isLoggedIn: true,
            isLoggedIn: window.utils.cookies.has('token'),
            showPasswordInfo: false,
            email: '',
            password: {
                token: null,
                password: '',
                confirm: '',
            },
            error: null,
            plan: null,
            tokens: 0,
            submitting: false,
            paymentButtonText: PROCESS,
            stripe: {
                stripe: null,
                //publicKey: 'pk_live_360ATOn250DwPCxjxIVwHEFT',
                publicKey: 'pk_test_bAY1qWl3bTyt0Oca3oS9S9De',
                elements: null,
                cardNumberElement: null,
                cardExpiryElement: null,
                cardCvcElement: null,
                succeeded: false,
                failed: false,
            },
            plans: {
                '51CE5A4D-7807-42E1-B2CD-562FC9A9926E': '5',
                '8C9828A7-B647-404D-8827-25016A957534': '12',
                'DAAD61EC-7A50-4768-ABC9-FB2417D30CAD': '20'
            }
        };
    },
    beforeMount() {
        const c = this;

        c.services.validateSession().then(() => {
            
        }).catch(() => {
            window.utils.cookies.delete('token');

            c.isLoggedIn = false;
            c.$emit('session-invalidated');
        });
    },
    created() {
        const c = this;

        c.checkPasswordReset();
        c.checkPaymentSession();
        c.getTokens();
    },
    computed: {
        isLandingView() {
            const searchParams = new URLSearchParams(window.location.search || '');
            const page = (searchParams.get('page') || '').toLowerCase();

            return page !== 'dashboard';
        }
    },
    methods: {
        checkPasswordReset() {
            const c = this;

            let resetToken = c.utils.url.param({url: window.location.href, name: 'reset-token'});

            if (resetToken) {
                c.showPasswordReset = true;
                c.password.token = resetToken;
            }
        },
        checkPaymentSession() {   
            let sessionToken = window.utils.url.param({url: window.location.href, name: 'session_id'});

            if (sessionToken) {

                const url = new URL(window.location);
                url.searchParams.delete('session_id');
                window.history.replaceState({}, '', url);

                Swal.fire({
                    title: 'Payement Complete',
                    text: 'Your payment has been successfully processed.',
                    icon: 'success',
                });
            }
        },
        openSignupModal() {
            this.showSignup = true;
        },
        login() {
            const c = this;

            c.error = null;

            c.services.login({
                email: c.email, 
                password: c.password.password,
            })
            .then(function (data) {
                window.utils.cookies.set('token', data.data.token);

                //window.checkPremium();

                setTimeout(function() {
                    window.location.reload();
                }, 300);
            })
            .catch(function () {
                c.error = INVALID_LOGIN;
            });
        },
        signup() {
            const c = this;

            if (!c.utils.validateEmail(c.email)) {
                c.error = INVALID_EMAIL;

                return;
            }

            if (!c.utils.validatePassword(c.password.password)) {
                c.error = INVALID_PASSWORD;

                c.showPasswordInfo = true;

                return;
            }

            c.error = null;

            c.services.signup({
                email: c.email, 
                password: c.password.password
            })
            .then(function (data) {
                window.utils.cookies.set('token', data.data.token);

                setTimeout(function() {
                    window.location.reload();
                }, 300);
            })
            .catch(function (error) {

                let response = error.response.data;

                if (response.error) {
                    c.error = error.response.data.error;
                } else if (response.key === 'email') {
                    c.error = INVALID_EMAIL;
                } else if (response.key === 'password') {
                    c.error = INVALID_PASSWORD;
                }
                
            });
        },
        googleAuth() {
            let clientId = '387766688869-dgidhqo3ehh0km8hi16f7qulmj6knc42.apps.googleusercontent.com';
            let redirectUrl = 'https://colorize.speedyimg.com';

            let scopes = [
                'openid',
                'https://www.googleapis.com/auth/userinfo.profile',
                'https://www.googleapis.com/auth/userinfo.email',
              ]
            
            scopes = scopes.join(' ')

            window.location.href = `https://accounts.google.com/o/oauth2/auth?scope=${scopes}&include_granted_scopes=true&response_type=token&state=state_parameter_passthrough_value&redirect_uri=${redirectUrl}&client_id=${clientId}`;
        },
        resetLoggedOutPasswordRequest() {
            const c = this;

            c.error = "";

            if (!c.email) {
                c.error = ENTER_EMAIL;
                return;
            }

            Swal.fire({
                title: 'Reset Password',
                text: "We will send you an email with a link to reset your password.",
                icon: 'success',
                showCancelButton: true,
                confirmButtonText: 'Reset'
            }).then((result) => {
                if (result.value) {

                    c.services.resetPassword({
                       email: c.email,
                    })
                    .then(function () {

                        Swal.fire({
                            title: 'Reset Password',
                            text: "We have sent an email to your inbox with a reset passoword link.",
                            icon: 'success',
                        });

                    })
                    .catch(function () {

                        Swal.fire({
                            title: 'Sorry, something went wrong.',
                            text: '',
                            icon: 'error',
                        });

                    });

                }
            });
        },
        resetPasswordRequest() {
            const c = this;

            // if (!c.email) {
            //     c.buttons.login.text = ENTER_EMAIL;
            //     c.buttons.login.error = true;
            // }

            Swal.fire({
                title: 'Reset Password',
                text: "We will send you an email with a link to reset your password.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Reset'
            }).then((result) => {
                if (result.value) {

                    c.services.resetPassword({
                       
                    })
                    .then(function () {

                        Swal.fire({
                            title: 'Reset Password',
                            text: "We have sent an email to your inbox with a reset passoword link.",
                            icon: 'success',
                        });

                    })
                    .catch(function () {

                        Swal.fire({
                            title: 'Sorry, something went wrong.',
                            text: '',
                            icon: 'error',
                        });

                    });

                }
            });
        },
        resetPassword() {
            const c = this;

            if (!c.password.token) {
                return;
            }

            c.error = null;

            if (!c.utils.validatePassword(c.password.password)) {
                c.error = INVALID_PASSWORD;

                return;
            }

            if (c.password.confirm !== c.password.confirm) {
                c.error = MISSMATCH_PASSWORD;

                return;
            }

            c.services.resetPassword({
                token: c.password.token, 
                password: c.password.password,
            })
            .then(function (data) {
                
                if (data.data.error) {
                    c.error = data.data.error;
                } else {

                    Swal.fire({
                        title: 'Password Reset',
                        text: "Password was successfully reset.",
                    }).then(() => {
                        setTimeout(function() {
                            window.location.replace(window.location.pathname);
                            window.location.reload();
                        }, 1000);
                    });

                }

            })
            .catch(function () {
                c.error = MISSMATCH_PASSWORD;
            });
        },
        deleteAccount() {
            const c = this;

            Swal.fire({
                title: 'Delete Account',
                text: "Are you sure you want to delete your account? This can't be undone.",
                type: 'warning',
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {

                    c.services.delete()
                    .then(function () {
                        c.logout();
                    })
                    .catch(function () {

                        Swal.fire({
                            title: 'Sorry, something went wrong.',
                            text: '',
                            type: 'error',
                        });

                    });
                }
            });
        },
        logout() {
            const c = this;

            c.utils.cookies.delete('token');

            window.location.href = `${getApiBaseUrl()}/api/user/logout`;
        },
        selectPlan(planID) {
            const c = this;

            c.plan = planID;

            c.processPayment();
        },
        getTokens() {
            const c = this;

            if (c.isLoggedIn) {
                c.services.getPurchase()
                .then(function (response) {
                    c.tokens = Number(response.data.tokens).toLocaleString();
                })
                .catch(function () {});
            }
        },
        processPayment() {
            const c = this;

            c.services.savePurchase({ itemID: c.plan })
            .then(function (response) {
                const session = response.data;

                if (session.url) {
                    window.location.href = session.url;
                } else {
                    c.error = session.error;
                    c.showError(session.error);
                }
            })
            .catch(function (error) {
                console.error('Payment Error:', error);
            });
        },
        showError(message = null) {
            const c = this;

            c.stripe.failed = true;
            c.paymentButtonText = FAILED;

            if (message) {

                Swal.fire({
                    title: 'Sorry, payment failed.',
                    text: message,
                    type: 'error',
                });

            }

            c.removeError();
        },
        removeError() {
            const c = this;

            setTimeout(function() {

                if (c.stripe.failed) {

                    c.stripe.succeeded = false;
                    c.stripe.failed = false;
                    c.submitting = false;

                }

            }, 3000);
        },
        close() {
            const c = this;

            c.showSignup = false;
            c.showLogin = false;
            c.showSettings = false;
            c.showPlans = false;
            c.showPayment = false;
            c.showPasswordReset = false;
        }
    }
}
</script>
<style>

.swal2-container {
  font-family: Arial, Helvetica, sans-serif; 
}

.swal2-popup {
    background: rgba(10, 12, 22, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.14);
    box-shadow: 0 24px 50px rgba(0, 0, 0, 0.45);
    color: #f5f6ff;
}

.swal2-cancel,
.swal2-deny,
.swal2-confirm {
    font-size: 15px;
    font-weight: 700;
}

.swal2-cancel,
.swal2-deny {
    border-radius: 999px;
    padding: 10px 24px;
    background: hsla(0, 0%, 100%, .08);
    color: #f5f6ff;
    border: 1px solid hsla(0, 0%, 100%, .2);
}

.swal2-confirm {
    background: #b6f65a !important;
    color: #0b0d17 !important;
    border-radius: 999px;
}

.swal2-info {
    color: #b6f65a !important;
    border-color: #b6f64a !important;
}
</style>

<style scoped>
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    background: rgba(5, 6, 13, 0.78);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    z-index: 100;
    zoom: .7;

    @media screen and (min-width: 768px) {
        zoom: 1;
    }
}

.header-content {
    box-sizing: border-box;
    max-width: none;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-areas: "start logo end";
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    column-gap: clamp(8px, 2vw, 20px);
    padding-inline: max(16px, env(safe-area-inset-left)) max(16px, env(safe-area-inset-right));
}

.logo {
    grid-area: logo;
    display: flex;
    height: 50px;
    justify-content: center;
    justify-self: center;
}

.logo-image {
    height: 100%;
    width: auto;
}

.header-links {
    grid-area: start;
    display: none;
    align-self: center;
    gap: 24px;
    min-width: 0;
}

.header-links-spacer {
    grid-area: start;
}

.header-links a {
    color: rgba(245, 246, 255, 0.86);
    font-size: 0.95rem;
    text-decoration: none;
}

button:not(.model-close) {
    position: relative;
    padding-right: 50px !important;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.35);
}

button:not(.model-close) i {
    font-size: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 6px;
}

.settings-btn i {
	right: 10px !important;
}

button:not(.model-close) i.icon-login,
button:not(.model-close) i.icon-logout {
    font-size: 31px;
}

.tokens {
    padding-top: 10px;
    padding-right: 10px;
    font-size: 15px;
    font-weight: 700;
}

.tokens span {
    color: #b6f65a;
}

.settings-btn,
.login-btn,
.premium-btn,
.signup-btn {
    padding: 10px 24px;
    background: rgba(255, 255, 255, 0.08);
    color: #f5f6ff;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 999px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.2s ease;
}

.signup-btn {
    background: #b6f65a;
    border-color: #b6f65a;
    color: #0b0d17;
}

.nav-items {
    grid-area: end;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    justify-self: stretch;
    align-self: center;
    min-width: 0;
}

.pricing-btn {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 999px;
    color: #f5f6ff;
    cursor: pointer;
    font-size: 14px;
    padding: 10px 16px;
}

.pricing-btn:hover,
.login-btn:hover,
.signup-btn:hover,
.submit-btn:hover,
.setting-btn:hover,
.model-close:hover {
    opacity: 0.5;
}

.login-btn {
    font-size: 14px;
}

@media screen and (min-width: 900px) {
    .header-links {
        display: flex;
    }
}

@media screen and (max-width: 899px) {
    .header-content {
        grid-template-areas: "logo end";
        grid-template-columns: auto minmax(0, 1fr);
        column-gap: 8px;
        padding-inline: max(12px, env(safe-area-inset-left)) max(12px, env(safe-area-inset-right));
    }

    .header-links-spacer {
        display: none;
    }

    .logo {
        justify-self: start;
        justify-content: flex-start;
    }
}

.model {
    margin: 0;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(3, 4, 10, 0.78);
    backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    border: none;
    border-radius: 0
}

.model-container {
    background: rgba(10, 12, 22, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.14);
    box-shadow: 0 24px 50px rgba(0, 0, 0, 0.45);
    color: #f5f6ff;
    padding: 24px;
    border-radius: 14px;
    min-width: 450px;
    position: relative;
    margin: 10px;
}

.model-close {
    position: absolute;
    top: 4px;
    right: 1px;
    background: transparent;
    border: none;
    color: rgba(245, 246, 255, 0.9);
    font-size: 20px;
    cursor: pointer;
}

.model input {
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    color: #f5f6ff;
    margin-bottom: 12px;
    padding: 11px 12px;
    display: block;
    width: 100%; 
    box-sizing: border-box;
}

.model input::placeholder {
    color: rgba(245, 246, 255, 0.55);
}

.model .submit-btn {
    padding: 11px 24px;
    background: #b6f65a;
    color: #0b0d17;
    border: 1px solid #b6f65a;
    border-radius: 999px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
}

.model .other {
    text-align: center;
    margin: 20px 0;
}

.model .google-btn {
    display: block;
    padding: 11px 24px;
    background: rgba(255, 255, 255, 0.08);
    color: #f5f6ff;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 999px;
    font-size: 15px;
    cursor: pointer;
    width: 100%;
    margin-top: 20px; 
}

.model .icon-info {
    position: absolute;
    right: 10px;
    top: 10px;
    color: rgba(245, 246, 255, 0.7);
    cursor: pointer;
}

.model .icon-info:hover {
    opacity: .5;
}

.model h2 {
    color: #f5f6ff;
    margin-top: 0;
    text-align: left;
}

.password-container {
    position: relative;
}

.model .setting {
    display: grid;
    grid-template-columns: 55% 45%;
    margin-bottom: 20px;
    text-align: left;

    p {
        margin-top: 21px;
    }
}

.model .setting:last-of-type {
    margin-bottom: 0;
}

.model .setting-btn {
    padding: 10px 24px !important;
    background: #b6f65a;
    color: #0b0d17;
    border: 1px solid #b6f65a;
    border-radius: 999px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    height: 42px;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    margin-top: 10px;
}

.model .subscriptions {
    border-top: 2px solid #808080;
    margin-top: 30px;
    padding-top: 30px;
}

.password-info {
    position: absolute;	
    background: rgba(12, 14, 26, 0.98);
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 10px;
    color: rgba(245, 246, 255, 0.9);
    right: 0;
    width: 300px;
    top: 230px;
    text-align: left;
    padding: 20px;

    @media screen and (min-width: 768px) {
        right: -368px;
        top: -38px;
    }
}

.password-info > p {
    font-weight: bold;
}

.password-info > div {
    padding-left: 20px;
}

.password-info > div > ul {
    list-style-type: disc;
    padding-left: 0; 
}

.error-text {
    background-color:rgb(173, 50, 50);
    color: #fff;
    border-radius: 999px;
    font-size: 15px;
    margin-top: 15px;

    p {
        margin: 0;
        padding: 5px;
        text-align: center;
    }
}

.plans_wrapper {
    display: grid;
    gap: 20px;

    @media screen and (min-width: 768px) {
        grid-template-columns: 200px 200px 200px;
    }
}

.plans_wrapper .plan {
    border-radius: 5px;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.35);
    padding-bottom: 10px;
    display: block;
}

.plans_wrapper .plan h3 {
    margin-top: 0;
    border-bottom: 1px solid #f5f6ff;
    padding: 10px 10px 10px 0;
}

.plans_wrapper .plan p {
    position: relative;
}

.plans_wrapper .plan i {
    color: #f5f6ff;
    position: relative;
    top: 2px;
    margin-right: 5px;
    font-size: 16px;
}

.is-disabled {
    opacity: .35;
    pointer-events: none;
}

.reset-password {
    border-top: 1px solid rgba(255, 255, 255, 0.14); 
    margin-top: 10px;
}

.reset-password button {
    margin-top: 10px;
    background: transparent;
    border: none;
    color: #b6f65a;
    box-shadow: none;
    font-size: 14px;
}

.reset-password button:hover {
    opacity: .5;
}

.model.payment .form label {
    text-align: left;
    display: block;
}

.model.payment .form .input {
    border: 1px solid #d7d6d6;
    border-radius: 3px;
    padding: 10px;
    display: block;
    margin: 10px 0 20px;
}

.model.payment .form .double {
    display: grid;
    grid-template-columns: calc(50% - 10px) calc(50% - 10px);
    gap: 20px;
}

.model.payment .form button {
    padding: 10px 24px;
    background: #b6f65a;
    color: #0b0d17;
    border: 1px solid #b6f65a;
    border-radius: 999px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.2s ease;
    width: 100%;
}

.footer a {
  margin: 0 10px;
  text-decoration: none;
  color: #b6f65a;
  transition: opacity 0.2s ease;
  font-size: 14px;
}

.footer a:hover {
  opacity: 0.8;
}
</style>
